// console.log('custom.js loaded');


  $(document).ready(function() {
  function initializeSliders() {
    // if ($(window).width() <= 768) {
    //   $('.mobile-slider').each(function() {
    //     if (!$(this).hasClass('slick-initialized')) {
    //       $(this).slick({
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         arrows: true,
    //         dots: false
    //       });
    //     }
    //   });
    // } else {
    //   $('.mobile-slider').each(function() {
    //     if ($(this).hasClass('slick-initialized')) {
    //       $(this).slick('unslick');
    //     }
    //   });
    // }

    if ($(window).width() <= 768) {
      $('.mobile-slider').each(function() {
        if (!$(this).hasClass('slick-initialized')) {
          $(this).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false
          });
        }
      });
     // filter slider
      $('.mobile-slider-filter').each(function() {
        if (!$(this).hasClass('slick-initialized')) {
          $(this).slick({
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: true,
            dots: false,
            variableWidth: true,
            infinite:true,
            draggable: true,
          });
        }
      });

    } else {
      $('.mobile-slider').each(function() {
        if ($(this).hasClass('slick-initialized')) {
          $(this).slick('unslick');
        }
      });

      // filter slider
      $('.mobile-slider-filter').each(function() {
        if ($(this).hasClass('slick-initialized')) {
          $(this).slick('unslick');
        }
      });
    }
  }

  // Run on page load
  initializeSliders();

  // Run on window resize
  $(window).on('resize', function() {
    initializeSliders();
  });

  // Re-initialize after AJAX content load
  $(document).ajaxComplete(function() {
    initializeSliders();
  });
});

function switchTab(chartId, button) {
            // Hide all size charts in the same section
            const section = button.closest('section');
            section.querySelectorAll('.size-chart').forEach(chart => {
                chart.classList.remove('active');
            });

            // Show the selected chart
            section.querySelector(`#${chartId}`).classList.add('active');

            // Update tab button styles within the same section
            section.querySelectorAll('.tab-button').forEach(tab => {
                tab.classList.remove('active');
            });
            button.classList.add('active');
        }

        